export const RASCUNHO_ID = 0;
export const ENVIADA_ID = 1;
export const REABERTURA_PENDENTE_ID = 2;
export const REABERTURA_EFETIVADA_ID = 3;
export const REABERTURA_CANCELADA_ID = 4;
export const CANCELADA_ID = 5;
export const PROCESSADA_ID = 6;
export const FATURADA_ID = 7;
export const TRANSMITIDO_ID = 8;
export const PAGO_ID = 9;
export const TRANSMITINDO_ID = 10;

// Manter alinhado com HTTP_TRANSMIT_CLAIM_ORIGINS no Nest (payroll.entity).
export const TRANSMITTABLE_PAYROLL_STATUS_IDS = [ENVIADA_ID, TRANSMITIDO_ID, PROCESSADA_ID, FATURADA_ID];

export const PAYROLL = {
  status: {
    [RASCUNHO_ID]: 'Rascunho',
    [ENVIADA_ID]: 'Enviada',
    [REABERTURA_PENDENTE_ID]: 'Reabertura Pendente',
    [REABERTURA_EFETIVADA_ID]: 'Reabertura efetivada',
    [REABERTURA_CANCELADA_ID]: 'Reabertura cancelada',
    [CANCELADA_ID]: 'Cancelado',
    [PROCESSADA_ID]: 'Processada',
    [FATURADA_ID]: 'Faturada',
    [TRANSMITIDO_ID]: 'Transmitida',
    [PAGO_ID]: 'Pago',
    [TRANSMITINDO_ID]: 'Enviada',
  },
};

export const PAYROLL_TRANSMISSION_ORIGIN_LABELS = {
  AUTOMATIC: 'AUTOMATICO',
  MANUAL_RETRY: 'MANUAL (retry)',
  MANUAL_DISABLED: 'MANUAL (desativado)',
};

export const STATUS_IDS = Object.keys(PAYROLL.status)
  .map((key) => Number(key))
  .filter((statusId) => statusId !== TRANSMITINDO_ID);

export const OPERATION_LOG = {
  status: {
    ENVIADA: 'Enviada',
    CANCELAMENTO: 'Cancelamento',
    PROCESSADA: 'Processada',
    SOLICITACAO_REABERTURA: 'Solicitação de reabertura',
    REABERTURA_EFETIVADA: 'Reabertura efetivada',
    REABERTURA_SEM_PEDIDO: 'Reabertura sem pedido',
    REABERTURA_NEGADA: 'Reabertura negada',
    FATURADA: 'Faturada',
    TRANSMITIDO: 'Transmitida',
    TRANSMITINDO: 'Enviada',
    PAGO: 'Pago',
  },
};

export const BENEFIT_ORDER = {
  status: {
    RASCUNHO: 'Em Andamento',
    TRANSMITIDO: 'Enviado',
    PROCESSADO: 'Processado',
  },

  reopeningStatus: {
    PENDING: 'Pendente',
    APPROVED: 'Aprovada',
    DENIED: 'Negada',
  },

  reopeningStatusColorMap: {
    PENDING: '#FDD835',
    APPROVED: '#00A89C',
    DENIED: '#FA075A',
  },
};
